import styled from 'foundations-theming/utils';
const BannersContainer = styled.div.withConfig({
  displayName: "BannersContainer",
  componentId: "sc-137i3i0-0"
})(["> *{margin-bottom:16px;}"]);
export default BannersContainer;